<template>
  <v-footer color="primary" padless>
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="primary text-center white--text"
        cols="12"
      >
        <small>Copyright © 2020 - {{ new Date().getFullYear() }} BKPSDM Kota Bandung | MANGBAGJA v1.3.{{version_date}}</small>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',
    data: () => ({}),
    computed:{
      version_date() {
        var date = new Date()
        var year = date.getFullYear().toString()
        var month = date.getMonth() < 10 ? '0'+parseInt(date.getMonth()+1) : date.getMonth()
        return year.substr(2, 4) + '' + month + '' + date.getDate()
      }
    }
  }
</script>